import { render, staticRenderFns } from "./manufactor-select.vue?vue&type=template&id=1b2536d2"
import script from "./manufactor-select.vue?vue&type=script&lang=js"
export * from "./manufactor-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports